// @flow

import { Info } from 'lucide-react';
import { Tooltip, View } from 'reshaped';

import { Icon } from '@gandi/reshaped';

export function InfoTooltip({
  content,
  children,
}: {
  content: React.Node | $ReadOnlyArray<string>,
  children: React.Node,
}): React.MixedElement {
  const text = Array.isArray(content) ? (
    <View as="ul" padding={1}>
      {content.map(line => (
        <li key={line}>{line}</li>
      ))}
    </View>
  ) : (
    content
  );

  return (
    <Tooltip text={text}>
      {attributes => (
        // $FlowFixMe[prop-missing]
        <View
          attributes={{
            ...attributes,
            style: { cursor: 'help' },
          }}
          direction="row"
          align="center"
          gap={1}
        >
          {children}
          <Icon svg={Info} size={4} color="neutral-faded" />
        </View>
      )}
    </Tooltip>
  );
}
